import { Avatar, Flex, Spinner, Text } from '@chakra-ui/react'
import { ModalBase } from '../../../../../components/ModalBase'

export interface iPessoaModal {
  id: string
  nome: string
  avatar?: string
}

interface iModalPessoasProps {
  isOpen: boolean
  titulo: string
  pessoas: iPessoaModal[]
  isLoading?: boolean
  onClose: () => void
}

export const ModalPessoas: React.FC<iModalPessoasProps> = ({ isOpen, titulo, pessoas, isLoading, onClose }) => {
  function AbrirPerfil(id: string): void {
    window.open(`/Rh/VisualizarPerfil/${id}`, '_blank')
  }

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} Titulo={titulo} Subtitulo={isLoading ? undefined : `${pessoas.length} ${pessoas.length === 1 ? 'colaborador' : 'colaboradores'}`} Width='44rem'>
      <Flex flexDir={'column'} p={'.5rem 1rem 1rem 1rem'} maxH={'60vh'} overflowY={'auto'}>
        {isLoading &&
          <Flex justifyContent={'center'} py={'2rem'}>
            <Spinner color='var(--Azul)' />
          </Flex>
        }
        {!isLoading && pessoas.length === 0 &&
          <Text textAlign={'center'} fontSize={'.875rem'} color={'var(--c6)'} py={'2rem'}>Nenhum colaborador vinculado.</Text>
        }
        {!isLoading && pessoas.length > 0 &&
          <Flex flexWrap={'wrap'} gap={'.5rem'}>
            {pessoas.map(e => (
              <Flex
                key={e.id}
                as={'button'}
                onClick={() => AbrirPerfil(e.id)}
                title='Abrir perfil em nova aba'
                alignItems={'center'}
                gap={'.75rem'}
                w={'calc(50% - .25rem)'}
                p={'.5rem .75rem'}
                borderRadius={'.5rem'}
                border={'1px solid var(--c3)'}
                bg={'var(--c1)'}
                color={'#000'}
                textAlign={'left'}
                _hover={{ bg: 'var(--c2)', borderColor: 'var(--Azul)' }}
              >
                <Avatar size={'sm'} src={e.avatar} name={e.nome} />
                <Text fontSize={'.875rem'} fontWeight={600} noOfLines={1}>{e.nome}</Text>
              </Flex>
            ))}
          </Flex>
        }
      </Flex>
    </ModalBase>
  )
}
